import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';

import { selectUserAccessoriesDetail } from 'shared/product_tabs/tab_accessories/slice/selectors';
import { removeAccessory } from 'shared/product_tabs/tab_accessories/slice/accessoriesSlice';

const AccessoriesDetail = () => {
  const dispatch = useDispatch();

  const user_accessories = useSelector(selectUserAccessoriesDetail);
  if (!user_accessories || user_accessories.length === 0) return null;

  const onDelete = (product_id) => {
    dispatch(removeAccessory({ product_id }));
  };

  return (
    <>
      {user_accessories.map((accessory, idx) => {
        const {
          product_id,
          product_title,
          quantity,
          item_total,
        } = accessory;

        return (
          <div className="cart-section cart-accessories" key={`cart-accessory-detail-${idx}`}>
            <div className="title row no-gutters">
              <div className="col-11">
                {product_title} X {quantity}
              </div>
              <div className="col-1">
                <button
                  type="button"
                  className="btn btn-link float-right btn-delete"
                  onClick={() => onDelete(product_id)}>
                  <FontAwesomeIcon icon={faTrashCan} />
                </button>
              </div>
            </div>
            <div className="position-relative">
              <div className="price">
                ${item_total}
              </div>
            </div>
          </div>
        );
      })}
    </>

  );
};

export default AccessoriesDetail;